import React, { useCallback, useEffect, useState } from "react";
import { Grid, GridItem, PageSection } from "@patternfly/react-core";
import UsageTable from "../components/usage/UsageTable";
import UsageToolbar from "../components/usage/UsageToolbar";
import { keyValueFilter } from "../utils/filterUtil";

export default (props) => {
  const data = props.data;

  const [itemCount, setItemCount] = useState(0);
  const [filterValue, setFilterValue] = useState("");

  const filterProducts = useCallback(() => {
    return keyValueFilter(data, "name", filterValue);
  }, [data, filterValue]);

  function handleFilterValueChange(filterValue) {
    setFilterValue(filterValue);
  }

  // filter data
  const [filteredData, setFilteredData] = useState(data);
  const [pageContent, setPageContent] = useState(data);

  useEffect(() => {
    const filteredProduct = filterProducts();
    if (filteredProduct) {
      setItemCount(filteredProduct.length);
    }
    setFilteredData(filteredProduct);
  }, [filterValue, filterProducts]);

  useEffect(() => {
    if (filteredData) {
      setPageContent(filteredData.slice(0, 10));
    }
  }, [filteredData]);

  function renderProductTables() {
    if (data && filteredData && pageContent) {
      return (
        <Grid hasGutter>
          <GridItem key={`activity-1`} span={12}>
            <UsageToolbar
              handleFilterValueChange={handleFilterValueChange}
              itemCount={itemCount}
              page={1}
              perPage={10}
              setPageContent={setPageContent}
              allPageContent={filteredData}
            />
            <UsageTable data={pageContent} />
          </GridItem>
        </Grid>
      );
    }
  }

  return <PageSection>{renderProductTables()}</PageSection>;
};
